/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_resize_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize keeping this ratio`)
};

const es_ar_resize_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionar manteniendo esta relación`)
};

const de_ar_resize_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe unter Beibehaltung dieses Verhältnisses ändern`)
};

const nl_ar_resize_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergroten/verkleinen met behoud van deze verhouding`)
};

const fr_ar_resize_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionner en gardant ce rapport`)
};

const it_ar_resize_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ridimensiona mantenendo questo rapporto`)
};

const pt_br2_ar_resize_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionar mantendo esta taxa`)
};

const pt_ar_resize_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionar mantendo esta proporção`)
};

const ja_ar_resize_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアスペクト比を保ったままリサイズ`)
};

const zh_ar_resize_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按此比例调整大小`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_resize_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_resize_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_resize_title", locale)
	if (locale === "en") return en_ar_resize_title(inputs)
	if (locale === "es") return es_ar_resize_title(inputs)
	if (locale === "de") return de_ar_resize_title(inputs)
	if (locale === "nl") return nl_ar_resize_title(inputs)
	if (locale === "fr") return fr_ar_resize_title(inputs)
	if (locale === "it") return it_ar_resize_title(inputs)
	if (locale === "pt-BR") return pt_br2_ar_resize_title(inputs)
	if (locale === "pt") return pt_ar_resize_title(inputs)
	if (locale === "ja") return ja_ar_resize_title(inputs)
	return zh_ar_resize_title(inputs)
};